// side effect: fetch llmf data
import {fetchRelux1, fetchRelux2, clearRelux1, clearRelux2} from '../slices/productDataSlice';
import {selectLightengine1Code, selectLightengine2Code} from '../selectors';

export const reluxMiddleware = store => next => action => {
    const result = next(action);

	// skip when feature is off
	if (store.getState().status.features.relux !== true) return result;

	if (action.type === 'decisions/decision/fulfilled' || action.type === 'decisions/consequencesLoading/fulfilled') {
        if (store.getState().session.sessionId !== null) {
            // after decision(s), get the new relux files
			const key1 = selectLightengine1Code(store.getState());
			if (key1 !== '') {
				store.dispatch(fetchRelux1({
					url: store.getState().status.expressUrl + '/relux?key=' + selectLightengine1Code(store.getState())
				}));
			} else {
				store.dispatch(clearRelux1());
			}
			// after decision(s), get the new relux files
			const key2 = selectLightengine2Code(store.getState());
			if (key2 !== '') {
				store.dispatch(fetchRelux2({
					url: store.getState().status.expressUrl + '/relux?key=' + selectLightengine2Code(store.getState())
				}));
			} else {
				store.dispatch(clearRelux2());
			}
        }
    }
    return result;
};
